const vendorCertification = (() => {
    let vendorID;
    let certificationEntries;
    let certificationTypePopup;
    let certificationTypeDropdownData;
    let oTable;

    async function init(vendorId) {
        vendorID = vendorId;
        certificationEntries = await authorizationsAjax.getVenderCertificationEntriesAsync(vendorID);
        certificationTypeDropdownData = await authorizationsAjax.getCertificationTypeDropdownData();
    }

    function getMarkup() {
        const vendorCertificationWrap = document.createElement('div');
        vendorCertificationWrap.classList.add('planSummary');

        const importantTables = buildNewCertificationForm();
        vendorCertificationWrap.appendChild(importantTables);

        return vendorCertificationWrap;
    }

    function buildNewCertificationForm() {
        const vendorCertificationDiv = document.createElement('div');
        vendorCertificationDiv.classList.add('additionalQuestionWrap');

        certificationEntriesTable = buildCertificationEntriesTable();

        const headers = certificationEntriesTable.querySelectorAll('.header div');
        headers[0].setAttribute('data-type', 'string'); // Certification
        headers[1].setAttribute('data-type', 'date'); // Start Date
        headers[2].setAttribute('data-type', 'date'); // End Date 

        const column1 = document.createElement('div')
        column1.classList.add('col-1')
        const addNewCard = document.createElement("div");
        addNewCard.classList.add("card");
        const addNewCardBody = document.createElement("div");
        addNewCardBody.classList.add("card__body");
        addNewCard.innerHTML = `<div class="card__header">Certification</div>`;
        addNewCard.appendChild(addNewCardBody)
        column1.appendChild(addNewCard)

        addNewCardBody.appendChild(certificationEntriesTable);
        vendorCertificationDiv.appendChild(column1);

        // Call function to allow table sorting by clicking on a header.
        table.sortTableByHeader(certificationEntriesTable); 

        return vendorCertificationDiv;
    }

    function buildCertificationEntriesTable() {
        const tableOptions = {
            plain: false,
            tableId: 'vendorInfoTable', 
            columnHeadings: ['Certification', 'Start Date', 'End Date'],                                   
            endIcon: false,
            callback: function (event) {
                let id = event.target.getAttribute('data-id');
                const entry = certificationEntries.getVenderCertificationEntriesResult.find(e => e.vendorCertificationID === id);
                if (entry) {
                    showNewCertificationPopup({
                        id: entry.vendorCertificationID,
                        certificationType: entry.vendorCertificationTypeId,
                        startDate: moment(entry.startDate).format('YYYY-MM-DD'),
                        endDate: entry.endDate !== ''? moment(entry.endDate).format('YYYY-MM-DD'): '',
                    });
                }
            },
        };
       
        oTable = table.build(tableOptions);
        populateTable();
        return oTable;
    }
    function populateTable() {       
        let tableData = certificationEntries.getVenderCertificationEntriesResult.map((entry) => ({
            attributes: [{ key: 'data-id', value: entry.vendorCertificationID }], 
            values: [entry.Certifiction, entry.startDate == '' ? '' : moment(entry.startDate).format('MM/DD/YYYY'), entry.endDate == '' ? '' : moment(entry.endDate).format('MM/DD/YYYY')],
        }));
        table.populate(oTable, tableData);
    }
    function showNewCertificationPopup(data) {
        let certificationType = data?.certificationType || null;
        let startDateValue = data?.startDate || null;
        let endDateValue = data?.endDate || null;        
        let isReadOnly = false;

        if (!data) {
            if ($.session.authorizationInsertVendorInfo) isReadOnly = false;
            else if (!$.session.authorizationInsertVendorInfo) isReadOnly = true;
        }
        else if (data) {
            if ($.session.authorizationsVendorInfoUpdate) isReadOnly = false;
            else if (!$.session.authorizationsVendorInfoUpdate) isReadOnly = true;
        }

        certificationTypePopup = POPUP.build({
            header: data ? 'Edit Certification' : 'Add New Certification',
            id: 'certificationPopup',
        });

        const certificationTypeDropdown = dropdown.build({
            id: 'certificationTypeDropdown',
            label: 'Certification',
            dropdownId: 'certificationTypeDropdown',
            value: '',
            readonly: isReadOnly
        });
        const certificationTypes = JSON.parse(certificationTypeDropdownData.getCertificationTypeDropdownDataResult) || [];
        var defaultDropdownOption = { value: '', text: '' };
        certificationTypes.unshift(defaultDropdownOption);
        dropdown.populate(certificationTypeDropdown, certificationTypes, certificationType||'');

        const startDate = input.build({
            label: 'Start Date',
            type: 'date',
            style: 'secondary',
            value: startDateValue,
            readonly: isReadOnly
        });
        const endDate = input.build({
            label: 'End Date',
            type: 'date',
            style: 'secondary',
            value: endDateValue,
            readonly: isReadOnly
        });       

        const saveBtn = button.build({
            id: 'certificationSave',
            text: data ? 'Apply' : 'Save',
            style: 'secondary',
            type: 'contained',
            callback: async () => {
                const result = await authorizationsAjax.saveVendorCertification({
                    id: data?.id || 0,
                    vendorId: vendorID,
                    certificationTypeId: certificationType,
                    startDate: startDateValue,
                    endDate: endDateValue,                   
                });
                const saveResult = result.saveVendorCertificationResult;
                if (saveResult === 'success') {
                    POPUP.hide(certificationTypePopup);
                    successfulSave.show(data ? 'Updated' : 'Saved');
                    setTimeout(function () {
                        successfulSave.hide();
                    }, 2000);
                    certificationEntries = await authorizationsAjax.getVenderCertificationEntriesAsync(vendorID);
                    populateTable();
                }
                else if (saveResult === 'exists') {
                    POPUP.hide(certificationTypePopup);
                    showAlreadyExistsWarning();
                }
            },
        });
        const cancelBtn = button.build({
            id: 'certificationCancel',
            text: 'cancel',
            style: 'secondary',
            type: 'outlined',
            callback: () => {
                POPUP.hide(certificationTypePopup);
            },
        });
        const btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');
        if (!isReadOnly) {
            btnWrap.appendChild(saveBtn);
        }
        btnWrap.appendChild(cancelBtn);

        certificationTypePopup.appendChild(certificationTypeDropdown);
        const dateWrap = document.createElement('div');
        dateWrap.style.display = 'grid';
        dateWrap.style.gridTemplateColumns = '1fr 1fr';
        dateWrap.style.gap = '10px';
        dateWrap.style.marginBottom = '10px';
        dateWrap.style.width = '100%';
        dateWrap.appendChild(startDate);
        dateWrap.appendChild(endDate);
        certificationTypePopup.appendChild(dateWrap); 
        const errorMsg = document.createElement('p');
        errorMsg.style.display = 'none';
        errorMsg.style.marginBottom = '15px';
        errorMsg.style.marginTop = '-15px';
        errorMsg.style.color = 'red';
        errorMsg.textContent = 'Start Date cannot be greater than the End Date';
        certificationTypePopup.appendChild(errorMsg);
        certificationTypePopup.appendChild(btnWrap);
        POPUP.show(certificationTypePopup);
        validatePopupFields();

        certificationTypeDropdown.addEventListener('change', function (e) {
            certificationType = e.target.value;
            validatePopupFields();
        });
        startDate.addEventListener('change', function (e) {
            startDateValue = e.target.value;
            validatePopupFields();
        });
        endDate.addEventListener('change', function (e) {
            endDateValue = e.target.value === '' ? null : e.target.value;      
            validatePopupFields();
        });      
        function validatePopupFields() {
            if (certificationType === null || certificationType === '') {
                certificationTypeDropdown.classList.add('error');
            }
            else {
                certificationTypeDropdown.classList.remove('error');
            }
            if (startDateValue === null || startDateValue === '') {
                startDate.classList.add('error');
            }
            else {
                startDate.classList.remove('error');
            }
            errorMsg.style.display = 'none';
            if ((startDateValue !== null && endDateValue !== null) && startDateValue > endDateValue) {
                errorMsg.style.display = 'block';
            } 
            var certificationPopupPopupDiv = document.getElementById('certificationPopup');
            var hasErrors = [].slice.call(certificationPopupPopupDiv.querySelectorAll('.error:not(button)'));
            if (hasErrors.length === 0) {
                saveBtn.classList.remove('disabled');
                const newData = { id: data?.id, certificationType, startDate: startDateValue, endDate: endDateValue || '' };
                const isChanged = data && JSON.stringify(data) !== JSON.stringify(newData);                
                if (errorMsg.style.display === 'block' || (data && !isChanged)) {
                    saveBtn.classList.add('disabled');
                }
            } else {
                saveBtn.classList.add('disabled');
            }
        }
        function showAlreadyExistsWarning() {
            var warningPopup = POPUP.build({});
            warningPopup.classList.add('warning');
            var message = document.createElement('p');
            message.innerHTML = 'This Certification overlaps with an existing Certification.';
            message.style.marginBottom = '15px';
            var btnWrap = document.createElement('div');
            btnWrap.classList.add('btnWrap');
            var okBtn = button.build({
                text: 'Ok',
                type: 'contained',
                style: 'secondary',
                callback: () => {
                    POPUP.hide(warningPopup);                    
                    POPUP.show(certificationTypePopup);
                }
            });

            btnWrap.appendChild(okBtn);
            warningPopup.appendChild(message);
            warningPopup.appendChild(btnWrap);
            POPUP.show(warningPopup);
            warningPopup.querySelector('.closePopupBtn').remove();
        }
    }
    return {
        init,
        buildNewCertificationForm,
        getMarkup,
        showNewCertificationPopup,
    };
})(); 
